<template lang="pug">
page(
    main-title="Собственная доставка",
    :links="[{component: 'DeliveryServices', title: 'Службы доставки'}, {component: 'EditManualDeliveryMethod', title: editedDM.name}, `${mode.text} ПВЗ`]"
)
    template(slot="description") {{ mode.text }} ПВЗ 
        b {{ editedItem.unique_id.value }}
    .panel
        .panel-body
            .row
                .col-md-6
                    field(
                        label="ID ПВЗ",
                        :item="editedItem.unique_id",
                        helpText="Значение должно быть <b>уникальным</b> для выбранного <b>способа доставки</b>"
                    )
                    .row
                        .col-md-6(v-for="phone in editedItem.phones")
                            field(
                                type="phone",
                                label="Телефон",
                                :item="phone"
                                @blur="onPhoneBlur(phone)"
                            )
                        .col-md-6.margin-bottom-20
                            button.btn.btn-default(@click="addPhoneField") 
                                | Ещё один номер
                    field(
                        type="select",
                        label="Населённый пункт",
                        :item="editedItem.city",
                        search-path="/fias/autocomplete/"
                    )
                    field(
                        label="Улица, дом, корпус/строение",
                        :item="editedItem.address",
                        @focus="onAddressFocus",
                        @blur="onAddressBlur"
                    )
                    .row
                        .col-md-6
                            field(
                                type="number",
                                label="Стоимость доставки, ₽",
                                :item="editedItem.delivery_price"
                            )
                        .col-md-6
                            field(
                                type="number",
                                label="Срок доставки, дней",
                                :item="editedItem.delivery_days"
                            )
                    field(
                        label="Режим работы",
                        :item="editedItem.schedule",
                        help-text="Например: пн-пт 10:00-20:00, сб-вс 10:00-16:00"
                    )
                    span.checkbox.checkbox-inline.padding-left-0.padding-right-10 Оплата: 
                    .checkbox.clip-check.check-primary.checkbox-inline
                        input(
                            id="online_payment_input"
                            type="checkbox", 
                            v-model="editedItem.online_payment"
                        )
                        label(for="online_payment_input") онлайн
                    .checkbox.clip-check.check-primary.checkbox-inline
                        input(
                            id="cash_payment_input"
                            type="checkbox", 
                            v-model="editedItem.cash_payment"
                        )
                        label(for="cash_payment_input") наличными
                    .checkbox.clip-check.check-primary.checkbox-inline
                        input(
                            id="card_payment_input"
                            type="checkbox", 
                            v-model="editedItem.card_payment"
                        )
                        label(for="card_payment_input") картой
                    field(
                        type="textarea",
                        label="Дополнительная информация",
                        :item="editedItem.address_description"
                        help-text="Показывается в <b>виджете</b>. Можно описать, например, как добраться от метро."
                    )

                #ya-maps-div.col-md-6.margin-bottom-10(style='height: 400px;')
            .row
                .col-md-12
                    p Ограничения по параметрам <b>товара</b> (если нет – не заполняйте):
                div.col-md-4
                    field(
                        type="number",
                        :item="editedItem.max_x"
                        label="Максимальная длина, см"
                    )
                div.col-md-4
                    field(
                        type="number",
                        :item="editedItem.max_y"
                        label="Максимальная ширина, см"
                    )
                div.col-md-4
                    field(
                        type="number",
                        :item="editedItem.max_z"
                        label="Максимальная высота, см"
                    )
                div.col-md-4
                    field(
                        type="number",
                        :item="editedItem.max_weight",
                        label="Максимальный вес, грамм"
                    )
                div.col-md-4
                    field(
                        type="number",
                        :item="editedItem.max_price",
                        label="Максимальная стоимость, ₽"
                    )
                div.col-md-12
                    field(
                        type="number",
                        :item="editedItem.order_by",
                        label="Порядок сортировки пункта (большее значение — пункт выводится выше)"
                    )


            button.btn.btn-o.btn-primary(@click.prevent="save") Сохранить
            button.btn.btn-o.btn-danger.margin-left-4(
                v-if="mode.type === 'update'",
                @click.prevent="remove"
            ) Удалить
            button.btn.btn-o.btn-primary.pull-right(@click.prevent="discard") Отмена
</template>

<script>
import { mapState } from 'vuex';

import Field from '@/components/core/Field';

import cloneDeep from 'lodash/cloneDeep';
import ymaps from 'ymaps';
import autosize from 'autosize';

const itemFields = [
    {name: 'unique_id', required: true},
    {name: 'phones'},
    {name: 'city', propname: 'full_name', required: true},
    {name: 'address', required: true},
    {name: 'delivery_price', required: true},
    {name: 'delivery_days', required: true},
    {name: 'schedule', required: true},
    {name: 'address_description'},
    {name: 'max_weight'},
    {name: 'max_price'},
    {name: 'max_x'},
    {name: 'max_y'},
    {name: 'max_z'},
    {name: 'order_by'}
];

export default {
    name: 'EditManualPvz',
    components: {
        Field
    },
    created() {
        if (!this.editedDM.id) {
            this.$router.push({name: 'DeliveryServices'});
        }

        ymaps.load('https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=eb8ff21b-ac54-447a-8e3a-263d30048c2a').then(maps => {
            if (this.isDestroyed) return;

            const map = new maps.Map('ya-maps-div', {
                center: [55.755814, 37.617635],
                zoom: 10,
                controls: ['zoomControl', 'searchControl']
            }, {
                searchControlProvider: 'yandex#search'
            });

            this.maps.api = maps;
            this.maps.map = map;

            this.maps.loaded = true;
            this.maps.onLoad && this.maps.onLoad();
        });
    },
    mounted() {
        if (this.mode.type === 'update') {
            this.maps.onLoad = () => {
                this.setCoordinates(this.editedItem.city.value.full_name,
                    this.editedItem.address.value);
            };
            if (this.maps.loaded) {
                this.maps.onLoad();
            }
        }

        autosize(document.querySelector('textarea'));
    },
    destroyed() {
        this.isDestroyed = true;
    },
    methods: {
        save() {
            if (!this.coordinates.upToDate) {
                this.coordinates.onChange = this.save;
                return;
            } else {
                this.coordinates.onChange = null;
            }

            if (this.validate()) {
                this.$store.dispatch('saveManualPvz', this.getValues())
                    .then(() => {
                        this.$router.push({name: 'EditManualDeliveryMethod'});
                    })
                    .catch(errors => {
                        if (!errors) return;
                        for (let error of errors) {
                            this.editedItem[error.field].valid = false;
                            this.editedItem[error.field].message = error.message;
                        }
                    });
            }
        },
        remove() {
            this.$store.dispatch('removeManualPvz', this.editedItem.id)
                .then(() => {
                    this.$router.push({name: 'EditManualDeliveryMethod'});
                });
        },
        discard() {
            this.$router.push({name: 'EditManualDeliveryMethod'});
        },
        getValues() {
            let item = cloneDeep(this.editedItem);

            for (let field of itemFields) {
                if (field.name !== 'phones') {
                    item[field.name] = item[field.name].value;
                }
            }

            item.phone = item.phones.filter(i => i.value).map(i => `7${i.value}`).join(', ');
            delete item.phones;

            item.aoguid = item.city.aoguid;
            delete item.city;

            item.delivery_method_id = this.editedDM.id;
            return item;
        },
        getInitialItem() {
            let item = cloneDeep(this.$store.state.deliveryServices.editedManualPvz);

            for (let field of itemFields) {
                item[field.name] = {
                    value: item[field.name],
                    valid: true,
                    message: ''
                };
            }

            if (!item.phone) {
                item.phones = [{value: '', valid: true, message: null}];
            } else {
                item.phones = [];
                for (let j of item.phone.split(',')) {
                    item.phones.push({
                        value: j.trim(),
                        valid: true,
                        message: null
                    });
                }
            }
            return item;
        },
        validate() {
            let valid = true;
            for (let field of itemFields) {
                if (field.required && !this.editedItem[field.name].value && this.editedItem[field.name].value !== 0) {
                    this.editedItem[field.name].valid = valid = false;
                    this.editedItem[field.name].message = 'Обязательно для заполнения';
                }
                if (['max_weight', 'max_price', 'max_x', 'max_y', 'max_z'].includes(field.name) &&
                        [0, '0'].includes(this.editedItem[field.name].value)) {
                    this.editedItem[field.name].valid = valid = false;
                    this.editedItem[field.name].message = 'Ноль – не лучшее значение для этого поля, оно отрежет все товары';
                }
            }
            for (let phone of this.editedItem.phones) {
                if (!phone.valid) valid = false;
            }
            return valid;
        },
        updateAutosize() {
            this.$nextTick(() => {
                autosize.update(document.querySelector('textarea'));
            });
        },
        onCityChanged() {
            if (this.editedItem.city.value && this.editedItem.city.value.full_name) {
                this.setCoordinates(this.editedItem.city.value.full_name,
                                    this.editedItem.address.value);
            }
        },
        onAddressFocus() {
            this.coordinates.upToDate = false;
            this.coordinates.addressFocusedNow = true;
        },
        onAddressBlur() {
            this.coordinates.addressFocusedNow = false;

            if (this.editedItem.city.value &&
                    this.editedItem.city.value.full_name &&
                    this.editedItem.address.value) {
                this.setCoordinates(this.editedItem.city.value.full_name,
                                    this.editedItem.address.value);
            }
        },
        setCoordinates(cityFullName, address) {
            let query = cityFullName;
            if (address) query = [query, address].join(', ');
            this.maps.api.geocode(query, {
                results: 1
            }).then(res => {
                let firstGeoObject = res.geoObjects.get(0),
                    coords = firstGeoObject.geometry.getCoordinates(),
                    bounds = firstGeoObject.properties.get('boundedBy');

                firstGeoObject.options.set('preset', 'islands#greenDotIconWithCaption');

                if (address) {
                    [this.editedItem.latitude, this.editedItem.longitude] = coords;

                    this.maps.map.geoObjects.removeAll();
                    this.maps.map.geoObjects.add(firstGeoObject);

                    if (!this.coordinates.addressFocusedNow) {
                        this.coordinates.upToDate = true;
                        this.coordinates.onChange && this.coordinates.onChange();
                    }
                }
                this.maps.map.setBounds(bounds, {
                    checkZoomRange: true
                });
            });
        },
        onPhoneBlur(item) {
            if (!item.value) {
                let i = this.editedItem.phones.findIndex(j => j === item);
                if (this.editedItem.phones.length > 1) this.editedItem.phones.splice(i, 1);
            }
        },
        addPhoneField() {
            this.editedItem.phones.push({value: '', valid: true, message: null});
        }
    },
    computed: {
        mode() {
            return {
                text: this.editedItem.id ? 'Редактирование' : 'Добавление',
                type: this.editedItem.id ? 'update' : 'create'
            };
        },
        ...mapState({
            editedDM: state => state.deliveryServices.editedManualDeliveryMethod
        })
    },
    watch: {
        'editedItem.city.value.full_name'(val) {
            this.onCityChanged();
        }
    },
    data() {
        let editedItem = this.getInitialItem();

        return {
            editedItem,

            coordinates: {
                upToDate: false,
                addressFocusedNow: false
            },

            maps: {}
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/components/deliveryServices/EditManualPvz.vue